var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',{attrs:{"cmpt":"SpacerRow","showBorder":_vm.showBorder}},[_c('Column',{staticClass:"rc-text-label",class:_vm.alignment()},[_c('br')])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }